const joinStatus = {

	/**
	 * Stripe subscription id's.
	 *
	 * @type {string}
	 */
	subscription_id_monthly: 'price_1LuXayJnethvgku8wokbzUhK', // $7 a month.
	// subscription_id_yearly: 'price_1LuXayJnethvgku80FJu1UpB', // $49 a year.
	subscription_id_yearly: 'price_1MoNqUJnethvgku8CvHZFfU2', // $48 a year.
	// subscription_lifetime: 'price_1OTt1dJnethvgku8VSLcWnmD', // $69 lifetime.

	subscription_id_monthly_test: 'price_1Lu1thJnethvgku8smP2EFI7',
	subscription_id_yearly_test: 'price_1Lu1thJnethvgku8fFOKPLGi',
	// subscription_lifetime_test: 'price_1QO6DZJnethvgku8Rk3mbIXp',


	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,


	/**
	 * Initialize the component.
	 */
	init: function() {

		const $comp = document.getElementById( 'join-status' );

		if ( !$comp ) {
			return;
		}

		joinStatus.app = new Reef(
			$comp,
			{
				data: members.app.data,
				template: joinStatus.template,
				attachTo: [ members.app ]
			}
		);

		members.app.render();

		$comp.addEventListener( 'click', joinStatus.click );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function( props ) {

		// Display only for users who are paid subscribers.
		if ( members.isSubscriber() ) {
			return joinStatus.userLoggedIn( props );
		}

		// Display for everyone else.
		return joinStatus.joinButtons( props );

	},


	/**
	 * Display useful links for subscribed users.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	userLoggedIn: function( props ) {

		return `
		<div class="position-s p4 bg-yellow b-br2">
			<h3 class="m-b3">Useful Links</h3>
			<ul>
				<li><a href="${ninja_props.stripe_account}">Manage/ Cancel Subscription</a></li>
				<li><a href="/members/animations/">Download Animation Files</a></li>
				<li><a href="/members/image-archive/">Image Archive Files</a></li>
				<li><a href="/members/contact/">Priority Contact</a></li>
				<li><a href="/members/roadmap/">Brush Ninja Roadmap</a></li>
				<li><a href="/members/profile/">Edit Profile</a></li>
			</ul>
		</div>
		`;

	},


	/**
	 * Buttons for logged out users, prompting to sign up.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	joinButtons: function( props ) {

		// console.log( window.location.host );
		let sub_monthly = joinStatus.subscription_id_monthly;
		let sub_yearly = joinStatus.subscription_id_yearly;
		// let sub_lifetime = joinStatus.subscription_lifetime;

		console.log( 'host', window.location.host );

		if ( members.isLocal() ) {
			// console.log( 'Test URL' );
			sub_monthly = joinStatus.subscription_id_monthly_test;
			sub_yearly = joinStatus.subscription_id_yearly_test;
			// sub_lifetime = joinStatus.subscription_lifetime_test;
		}

		// <div class="button-description">
		// 	<a
		// 		href="#"
		// 		class="button secondary"
		// 		id="signup-lifetime"
		// 		data-id="${sub_lifetime}"
		// 	>Join for ${ninja_props.price_lifetime} One time &rarr;</a>
		// 	<p>BEST VALUE!</p>
		// </div>

		return `
		<div class="position-s grid p-t4">
			<div class="button-description">
				<a
					href="#"
					class="button"
					id="signup-yearly"
					data-id="${sub_yearly}"
				>Join for ${ninja_props.price_yearly} a year &rarr;</a>
				<p>$4 A MONTH!</p>
			</div>
			<a
				href="#"
				class="button"
				id="signup-monthly"
				data-id="${sub_monthly}"
			>Join for ${ninja_props.price_monthly} a month &rarr;</a>

			<img src="/assets/images/cc/group.png" alt="Credit Card Logos" class="o60 p-x3 o100__hover" />

			<div class="o60 o100__hover t-ta-c f5">
				<p>All payments include a 7-day refund period. You can cancel subscriptions at any time. <a href="/terms-and-conditions/#refunds-and-cancellations">Full Terms & Conditions</a>.</p>
			</div>
		</div>`;

	},

};